const ACCENT_CLASSES = {
  violet: "bg-(--pastel-violet-soft) text-(--brand-primary)",
  blue: "bg-(--pastel-blue) text-(--status-info)",
  green: "bg-(--pastel-green) text-(--status-success)",
  amber: "bg-(--pastel-amber) text-(--status-warn)",
  rose: "bg-(--pastel-rose) text-(--status-danger)",
};

const SIZE_MAP = {
  sm: { wrapper: "h-8 w-8 rounded-[9px]", icon: 16 },
  md: { wrapper: "h-10 w-10 rounded-[11px]", icon: 19 },
};

export default function RowIcon({
  icon: Icon,
  children,
  accent = "violet",
  size = "md",
  className = "",
}) {
  const accentClass = ACCENT_CLASSES[accent] ?? ACCENT_CLASSES.violet;
  const sizeConfig = SIZE_MAP[size] ?? SIZE_MAP.md;
  return (
    <div
      className={`flex shrink-0 items-center justify-center ${sizeConfig.wrapper} ${accentClass} ${className}`.trim()}
    >
      {Icon ? <Icon size={sizeConfig.icon} strokeWidth={1.8} /> : children}
    </div>
  );
}
